// libraries
import { Outlet } from "react-router-dom";

import PublicNavbar from "../../../../components/PublicNavbar";
import Footer from "../../../../components/Footer";

function Base() {
  return (
    <>
      <PublicNavbar />
      <Outlet />
      <Footer />
    </>
  );
}

export default Base;
